<template>
  <ContainerWrapper>
    <OffersList v-if="cptdDisplayAffiliates" title="Consignado Imobiliário">
      <ZilicredOfferCardContainer v-if="cptdDisplayZilicred" key="ZILICRED" />
    </OffersList>
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import { getHomeEquityPayrollAffiliates } from '@/helpers/loans/home-equity-payroll/affiliates'
import { Partner } from '@/data/common'
import ZilicredOfferCardContainer from '~/containers/loans/home-equity-payroll/offer/affiliates/zilicred/ZilicredOfferCardContainer.vue'
export default {
  name: 'HomeEquityPayrollOffersListContainer',
  components: {
    ZilicredOfferCardContainer,
    ContainerWrapper,
    OffersList,
  },
  computed: {
    ...mapGetters({
      gtCreditScoreLatest:
        'products/credit-score/credit-score/gtCreditScoreLatest',
      gtHomeEquityLatestColdOfferRequest:
        'products/loans/home-equity/cold-offer/gtHomeEquityLatestColdOfferRequest',
      gtHomeEquityExtraQuestions:
        'products/loans/home-equity/cold-offer/gtHomeEquityExtraQuestions',
    }),
    cptdDisplayZilicred() {
      return this.cptdAvailableAffiliates[Partner.ZILICRED]
    },
    cptdDisplayAffiliates() {
      return this.cptdDisplayZilicred
    },
    cptdAvailableAffiliates() {
      return getHomeEquityPayrollAffiliates(
        this.gtHomeEquityLatestColdOfferRequest,
        this.gtHomeEquityExtraQuestions,
        this.gtCreditScoreLatest?.data?.score || 300,
      )
    },
  },
}
</script>
<style lang="scss"></style>
